export default __webpack_public_path__ + "static/PMG_EGTB_HOHH_PDS_ENG_2605V0.2-a5e109e1b0c0dab97153cf251519a599.pdf";